import Vue from "vue";
//import { v4 as uuidv4 } from 'uuid';
import "../filters";
import {
  DxDataGrid,
  DxColumn,
  DxButton,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxPager,
  DxColumnFixing,
} from "devextreme-vue/data-grid";
import ldf from "@/localDataFunctions";
import { mixin } from "vue/types/umd";

export default {
  name: "datagrid",
  components: {
    DxColumn,
    DxButton,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxPager,
    DxColumnFixing,
    //SearchComp: require('@/customcontrols/dataGridSearch/dataGridSearch.vue').default,
  },
  props: {
    ///////////////////////////////////////////////////
    higlightRowOnClick: {
      type: Boolean,
      default: true,
    },
    doubleClickNoteRemove: {
      type: Boolean,
      default: false,
    },
    showDoubleClickNotes: {
      type: Boolean,
      default: true,
    },
    showSingleClickNotes: {
      type: Boolean,
      default: false,
    },
    showDoubleClickNotesEdit: {
      type: Boolean,
      default: false,
    },
    onCellClick: {
      type: Function,
    },
    onRowDbClick: {
      type: Function,
    },
    selectionChanged: {
      type: Function,
    },
    //////////////////////////////////////////////////
    pageSize: {
      type: Number,
      default: 100,
    },
    title: {
      type: String,
      default: "",
    },
    data_source: {
      type: Array,
      required: true,
    },
    cols: {
      type: Array,
      required: true,
    },
    allowPaging: {
      type: Boolean,
      default: true,
    },
    keyColumn: {
      type: String,
    },
    selection: {
      type: String,
      default: "single",
    },
    selectAllMode: {
      type: String,
      default: "allPages",
    },
    showCheckBoxesMode: {
      type: String,
      default: "onClick",
    },
    summaryColumn: {
      type: String,
    },
    allowUpdating: {
      type: Boolean,
      default: false,
    },
    allowDeleting: {
      type: Boolean,
      default: false,
    },
    allowAdding: {
      type: Boolean,
      default: false,
    },
    allowColumnReordering: {
      type: Boolean,
      default: true,
    },
    allowColumnResizing: {
      type: Boolean,
      default: true,
    },
    columnAutoWidth: {
      type: Boolean,
      default: true,
    },
    rowAlternationEnable: {
      type: Boolean,
      default: true,
    },
    showColumnLines: {
      type: Boolean,
      default: true,
    },
    showRowLines: {
      type: Boolean,
      default: true,
    },
    showBorders: {
      type: Boolean,
      default: true,
    },
    calculateCellClass: {
      type: Function,
    },
    rtl: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    pageOptions: {
      type: Object,
    },
    pageChanging: {
      type: Function,
    },
    isRemotePaging: {
      type: Boolean,
      default: false,
    },
    isDisablePaging: {
      type: Boolean,
      default: false,
    },
    stateStoringEnabled: {
      type: Boolean,
      default: false,
    },
    stateStoringKey: {
      type: String,
    },
    styleClass: {
      type: String,
      default: "",
    },
    clearSelection: {
      type: Function,
    },
    downloadRecordsFunction: {
      type: Function,
      default: null,
    },
    disableRemotePaging: {
      type: Boolean,
      default: false,
    },
    showDoneButton: {
      type: Boolean,
      default: false,
    },
    allowAutoExpand: {
      type: Boolean,
      default: true,
    },
    allowGroupPanel: {
      type: Boolean,
      default: true,
    },
    allowColumnFixing: {
      type: Boolean,
      default: false,
    },
    showRefreshRecordsButt: {
      type: Boolean,
      default: true,
    },
    refName: {
      type: String,
      default: "devExtremeGrid",
    },
    employeeStationId: {
      type: Number,
      default: -1,
    },
  },
  mixins: [ldf],
  data: function () {
    return {
      lockGrid: false,
      rowsIndexSelected: [-1],
      showSearchDialog: false,
      selectedRowData: {},
      enableDownloadRecordsButt: false,
      options: { pageSize: 10, total: 0, page: 1, from: null, to: null },
      totalRow: 0,
      filterBuilderPopupPosition: {
        of: window,
        at: "top",
        my: "top",
        offset: { y: 10 },
      },
      editButtons: [
        {
          hint: "Edit",
          icon: "edit",
          visible: true,
          onClick: this.onGridCellClick,
        },
      ],
      pageSizes: [5, 10, 20],
      focusedRowKey: "",
      dataGridRefName: "dataGrid",
      localLang: "",
      selectedRowKeys: [],
      gridCols: [],
    };
  },
  computed: {
    GetSummaryColumnName: function () {
      return (
        this.summaryColumn ||
        (Array.isArray(this.data_source) &&
          this.data_source.length &&
          Object.keys(this.data_source[0])[0])
      );
    },
    dGrid: function () {
      return this.$refs.devExtremeGrid.instance;
    },
    enableSearchDialog: function () {
      return (
        this.data_source &&
        this.cols &&
        this.data_source.length > 0 &&
        this.cols.length > 0
      );
    },
    searchDataSource: function () {
      return this.data_source;
    },
  },
  created() {
    this.enableDownloadRecordsButt = this.downloadRecordsFunction != null;
    //this is so the datagrid accepts the column input
    this.resetColumns();

    this.$root.$on("datagrid_updated", this.init);
    this.localLang = this.$localStorage.get("_lang");
    this.init();
  },
  mounted() {
    this.$root.$on(`refresh_data_grid:${this.refName}`, this.refreshGrid);

    this.lockGrid = this.getFromLocal("lock_grid");
  },
  beforeDestroy() {
    //this.clear();
    if (this.clearSelection) {
      this.clearSelection();
    }
  },
  methods: {
    lockGridFunc(val) {
      this.saveToLocal("lock_grid", val);
    },
    getTemplateName() {
      return "getTemplateNames";
    },
    cellTemplate(c) {
      //console.log("c", c)
      return c.dataType == "icon"
        ? "iconCol"
        : c.stationAccessHighlight
        ? "stationAccessHighlightApplicationCol"
        : c.highlight
        ? "highlightApplicationCol"
        : c.accessHighlight
        ? "accessHighlightApplicationCol"
        : c.tempName;
    },
    searchComplete(item) {},
    onCellPrepared(e) {
      //if (e.rowType === "data" && this.rowsIndexSelected.filter(r => r == e.rowIndex).length == 1) {
      //  e.cellElement.classList.add("cell-highlighted");
      //}
    },
    downloadRecords() {
      this.downloadRecordsFunction();
    },
    clear() {},
    init() {
      Vue.nextTick(() => {
        this.totalRow = this.data_source.length;
        this.focusedRowKey = this.keyColumn;
      });
    },
    resetColumns() {
      this.gridCols = [];
      this.gridCols = JSON.parse(JSON.stringify(this.cols));
    },
    pageChange(pInfo) {
      var parameters = {
        PageSize: pInfo.pageSize,
        Page: pInfo.pageNumber,
        From: this.options.from,
        To: this.options.to,
      };
    },
    onFocusedRowChanging(e) {
      var pageSize = e.component.pageSize(),
        pageIndex = e.component.pageIndex(),
        isLoading = e.component.getController("data").isLoading(),
        key = e.event && e.event.key;

      if (!isLoading) {
        if (key && e.prevRowIndex === e.newRowIndex) {
          if (e.newRowIndex === pageSize - 1) {
            e.component.pageIndex(pageIndex + 1).done(function () {
              e.component.option("focusedRowIndex", 0);
            });
          } else if (e.newRowIndex === 0) {
            e.component.pageIndex(pageIndex - 1).done(function () {
              e.component.option("focusedRowIndex", pageSize - 1);
            });
          }
        }
      }

      if (this.selectionChanged) {
        this.selectionChanged(e);
      }
    },
    onFocusedRowChanged: function (e) {
      var data = e.row && e.row.data;
      this.taskSubject = data && data.Task_Subject;
      this.taskDetails = data && data.Task_Description;
      this.taskStatus = data && data.Task_Status;
      this.focusedRowKey = e.component.option("focusedRowKey");
    },
    onGridCellClick(info) {
      this.selectedRowData = info.data;

      if (this.onCellClick) {
        this.onCellClick(info);
      }
    },
    onGridRowDbClick(info) {
      if (this.onRowDbClick) {
        this.onRowDbClick(info);
      }
    },
    doneActions() {
      if (this.onRowDbClick) this.onRowDbClick({ data: this.selectedRowData });
    },
    onSelectionChanged(info) {
      var aa = this.dGrid.getSelectedRowsData();

      if (this.selectionChanged) {
        this.selectionChanged(info, {
          aa,
          se: this.dGrid.getSelectedRowsData(),
        });
      }
    },
    clearSelectedRows() {
      this.dGrid.clearSelection();
      this.dGrid.deselectAll();

      if (this.clearSelection) {
        this.clearSelection();
      }
    },
    installmentBtnClickHandler(data) {
      this.$parent.showInstallments(data);
    },

    refreshGrid() {
      if (this.$refs[this.refName] && this.$refs[this.refName].instance)
        this.$refs[this.refName].instance.refresh();
    },
    checkForStation(station) {
      let prof = this.$store.getters.getUserProfile;
      if (!prof || !prof.employeeStationId || prof.employeeStationId < 0)
        return false;

      return prof.employeeStationId == station;
    },
    //searchDialogClosed(items) {
    //  let indexes = [], curItem = {};
    //  if (items && items.length > 0) {
    //    let index = -1;

    //    for (let i = 0; i < items.length; i++) {
    //      curItem = items[i];
    //      index = this.data_source.findIndex(object => object.applicationId == curItem['applicationId']);

    //      if (index >= 0)
    //        indexes.push(index);
    //    }
    //  }

    //  this.rowsIndexSelected = [...indexes];
    //  if (this.rowsIndexSelected.length > 0 && indexes.length > 0)
    //    this.refreshGrid();

    //  this.showSearchDialog = false;
    //},
  },
};
